import React, { useEffect } from 'react';
import { OverlayKind } from '../../game/presentation';

interface CelebrationProps {
  kind: OverlayKind;
  message: string;
  onDone: () => void;
}

const TITLES: Record<Exclude<OverlayKind, null>, string> = {
  solve: 'Solved!',
  bankrupt: 'Bankrupt!',
  win: 'Jackpot',
  pass: 'Pass',
  hit: 'Nice hit',
};

const HOLD: Record<Exclude<OverlayKind, null>, number> = {
  solve: 2400,
  bankrupt: 1700,
  win: 2800,
  pass: 900,
  hit: 700,
};

const BURST_COUNT = 16;

const Celebration: React.FC<CelebrationProps> = ({ kind, message, onDone }) => {
  useEffect(() => {
    if (!kind || kind === 'win') return undefined;
    const timer = window.setTimeout(onDone, HOLD[kind]);
    return () => window.clearTimeout(timer);
  }, [kind, onDone]);

  if (!kind || kind === 'win') {
    return null;
  }

  const compact = kind === 'hit' || kind === 'pass';

  return (
    <div
      className={`ss-overlay is-center ss-cele-overlay is-${kind}${compact ? ' is-compact' : ''}`}
      role="status"
      aria-live="assertive"
    >
      <div className={`ss-burst is-${kind}`} aria-hidden="true">
        {Array.from({ length: BURST_COUNT }, (_, index) => (
          <span key={index} className="ss-burst-bit" style={{ '--i': index } as React.CSSProperties} />
        ))}
      </div>
      <div className={`ss-modal ss-cele is-${kind}`}>
        <div className="big">{TITLES[kind]}</div>
        {message ? <p className="ss-sub">{message}</p> : null}
      </div>
    </div>
  );
};

export default Celebration;
